import { ImmHelper } from "@base/util/Immutable";

export type IReducerHelper<S extends object> = {
  _set: (_old: S, newState: S) => S;
  _setProperty: <P extends keyof S>(old: S, property: P, value: S[P]) => S;
  _update: (old: S, fn: (old: S) => S) => S;
}

export class ReducerHelper {
  static createReducerHelper<S extends object>(): IReducerHelper<S> {
    const helper: IReducerHelper<S> = {
      _set: (_old: S, newState: S) => newState,
      _setProperty: <P extends keyof S>(old: S, property: P, value: S[P]): S => ImmHelper.setProperty(old, property, value),
      _update: (old: S, fn: (old: S) => S) => fn(old)
    }
    return helper;
  }
}